import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import StylistSidebar from "./StylistSidebar";
import TourHelpButton from "../TourHelpButton";
import TourSpotlight from "../TourSpotlight";

export default function StylistLayout() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F9F6ED]">
        <div className="w-8 h-8 border-2 border-rose-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <div className="flex min-h-screen bg-[#F9F6ED]" data-testid="stylist-layout">
      <StylistSidebar />
      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
      <TourHelpButton />
      <TourSpotlight />
    </div>
  );
}
